import React from 'react';

import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import useMartyContext from 'hooks/useMartyContext';
import ToggleButton from 'components/common/ToggleButton';

import css from 'styles/components/search/facetActions.scss';

export const FacetActions = ({
  clearFacetGroup,
  selectedFacet,
  facetDone,
  mobileCloseFiltersText,
  mobileRemoveSelectionsText,
  isShowAutoFacetToggle,
  handleAutoFacetToggle,
  autoFacetCookie
}) => {
  const {
    testId,
    marketplace: {
      search: { hasFacetListClear }
    }
  } = useMartyContext();

  return (
    <div className={css.facetActions}>
      {isShowAutoFacetToggle && (
        <div className={css.autoFacetToggleContainer}>
          <div className={css.copyContainer}>
            <div className={css.mainCopy}>Assist Filters</div>
            <div className={css.subCopy}>We applied filters based on your awesome search</div>
          </div>
          <div>
            <ToggleButton id="assistFiltersMobile" handleToggle={handleAutoFacetToggle} isToggledDefault={autoFacetCookie !== 'off'} />
          </div>
        </div>
      )}
      <div className={css.buttonContainer}>
        <button type="button" className={css.resetFacets} onClick={clearFacetGroup} data-test-id={testId('resetFacets')}>
          {mobileRemoveSelectionsText} {hasFacetListClear && selectedFacet ? selectedFacet.facetFieldDisplayName : 'All'}
        </button>
        <button type="button" data-test-id={testId('facetDone')} className={css.done} onClick={facetDone}>
          {mobileCloseFiltersText}
        </button>
      </div>
    </div>
  );
};

FacetActions.displayName = 'FacetActions';
export default withErrorBoundary('FacetActions', FacetActions);
